import { useState } from 'react';
import { useTaskList } from '../tasks/useTasks.js';
import { TimerDial } from './PomodoroTimer.js';
import { formatClock, usePomodoro } from './usePomodoro.js';

/**
 * Cronometro livre (spec 9.3).
 *
 * Mesmo motor do pomodoro, com `plannedS = 0`: conta para cima e nao encerra
 * sozinho. O anel fica vazio de proposito — sem duracao planejada nao existe
 * "quanto falta", e um anel enchendo sem destino seria decoracao mentirosa.
 */
export function Stopwatch() {
  const { session, elapsedS, start, stop } = usePomodoro();
  const [taskId, setTaskId] = useState('');
  const { data: hoje } = useTaskList({ view: 'today' });

  const rodando = session?.mode === 'stopwatch';
  // Uma sessao de pomodoro em andamento bloqueia o cronometro: sao o mesmo
  // registro no banco, e comecar um encerraria o outro sem aviso.
  const ocupadoComPomodoro = session !== null && !rodando;

  return (
    <div className="flex flex-col items-center gap-5">
      <TimerDial display={formatClock(rodando ? elapsedS : 0)} progress={0} label="Cronômetro" />

      {ocupadoComPomodoro ? (
        <p className="max-w-xs text-center text-sm text-text-mut">
          Há um pomodoro em andamento. Encerre-o na aba Pomo para usar o cronômetro.
        </p>
      ) : rodando ? (
        <button
          type="button"
          onClick={() => stop(true)}
          className="min-h-touch rounded bg-brand-blue px-6 font-medium text-white transition-colors duration-150 hover:bg-brand-blue-hover"
        >
          Parar
        </button>
      ) : (
        <>
          <div className="flex w-full max-w-xs flex-col gap-1">
            <label htmlFor="stopwatch-task" className="text-sm text-text-mut">
              Vincular a uma tarefa
            </label>
            <select
              id="stopwatch-task"
              value={taskId}
              onChange={(event) => setTaskId(event.target.value)}
              className="min-h-touch rounded border border-border bg-surface px-3 text-base"
            >
              <option value="">Sem tarefa</option>
              {(hoje?.tasks ?? []).map((task) => (
                <option key={task.id} value={task.id}>
                  {task.title}
                </option>
              ))}
            </select>
          </div>

          <button
            type="button"
            onClick={() => start('stopwatch', taskId === '' ? null : taskId)}
            className="min-h-touch rounded bg-brand-blue px-6 font-medium text-white transition-colors duration-150 hover:bg-brand-blue-hover"
          >
            Começar
          </button>
        </>
      )}
    </div>
  );
}
